import { render } from "./AuthOverlay.vue?vue&type=template&id=4a437c9b&scoped=true"
import script from "./AuthOverlay.vue?vue&type=script&lang=js"
export * from "./AuthOverlay.vue?vue&type=script&lang=js"

import "./AuthOverlay.vue?vue&type=style&index=0&id=4a437c9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a437c9b"]])

export default __exports__